import { WarningModal } from "features/modal";
import React, { PropsWithChildren, createContext, useContext } from "react";
import { Redirect } from "react-router-dom";
const AuthContext = createContext(false);

const PrivateRoute: React.FC = ({ children }) => {
  const accessToken = localStorage.getItem("accessToken") || null;
  const refreshToken = localStorage.getItem("refreshToken") || null;
  const isLoggedIn = accessToken !== null && refreshToken !== null;

  return (
    <AuthContext.Provider value={isLoggedIn}>
      <Main>{children}</Main>
    </AuthContext.Provider>
  );
};

const Container = ({ children }: PropsWithChildren<{}>) => {
  return (
    <>
      {children}

      <WarningModal />
    </>
  );
};

const Main: React.FC = ({ children }) => {
  const loggedIn = useContext(AuthContext);
  if (!loggedIn) {
    localStorage.clear();
    return <Redirect to="auth/login" />;
  }
  return <Container>{children}</Container>;
};

export default PrivateRoute;
